/** Slugs obrigatórios no pipeline (entrada, conversão, handoff IA). Alinhado com is_protected_lead_stage_slug no DB. */
export const PROTECTED_LEAD_STAGE_SLUGS = [
  "novo",
  "ganho",
  "perdido",
  "atendimento_humano",
] as const;

export type ProtectedLeadStageSlug = (typeof PROTECTED_LEAD_STAGE_SLUGS)[number];

export function isProtectedLeadStageSlug(slug: string | null | undefined): boolean {
  if (!slug) return false;
  return (PROTECTED_LEAD_STAGE_SLUGS as readonly string[]).includes(slug);
}

export function canDeleteLeadStage(stage: {
  slug: string;
  is_system?: boolean;
}): boolean {
  return !isProtectedLeadStageSlug(stage.slug);
}

const PROTECTED_STAGE_REASONS: Record<ProtectedLeadStageSlug, string> = {
  novo: "Estágio de entrada de novos leads — não pode ser excluído.",
  ganho: "Estágio de conversão (ganho) — não pode ser excluído.",
  perdido: "Estágio de conversão (perdido) — não pode ser excluído.",
  atendimento_humano:
    "Estágio usado pela transferência para atendimento humano e pausa da IA — não pode ser excluído.",
};

export function protectedLeadStageDeleteReason(slug: string): string {
  if (isProtectedLeadStageSlug(slug)) {
    return PROTECTED_STAGE_REASONS[slug as ProtectedLeadStageSlug];
  }
  return "Este estágio é obrigatório no pipeline.";
}
